import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_LANG, isSupportedLang, readStoredLang } from "../i18n/langs";

// 화면 언어. 저장·<html lang> 반영 같은 부수효과는 store.js 의 bindLangToStore 가 맡는다.
const initialState = {
  current: readStoredLang() || DEFAULT_LANG,
};

const langSlice = createSlice({
  name: "lang",
  initialState,
  reducers: {
    setLang: (state, action) => {
      if (isSupportedLang(action.payload)) state.current = action.payload;
    },
  },
});

export const { setLang } = langSlice.actions;
export default langSlice.reducer;
